// @core/api/endpoints/affiliate/approve_conversion.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ApproveConversionRequest,
  ConversionResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Approve conversion
 * Performs approve operation on conversion.
 */
export async function ApproveConversion(
  conversion_id: string,
  data: ApproveConversionRequest,
  options?: RequestOptions
): Promise<ConversionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversions/:conversion_id/approve`;
  requestPath = requestPath.replace(':conversion_id', encodeURIComponent(conversion_id));
  const requestOptions = options;
  return client.post<ConversionResponse>(requestPath, data, requestOptions);
}
